import { ReactElement, useMemo } from 'react';
import { Trans } from 'react-i18next';
import { DefaultTheme, useTheme } from 'styled-components';

import { Address } from '@dreryk/address-common-api';

import { Link, MessageOptions } from '@dreryk/react-components';

import { draftPrescriptionsTranslationKeys } from '../../../../../translations';

import { StyledPatientAddressIncompleteStatus } from './PatientAddressIncompleteStatus.styled';
import { PatientAddressModalOpener } from './modal/PatientAddressModal.opener';

enum PatientIncompleteStatusType {
   INCOMPLETE = 'INCOMPLETE',
}

const createOptions = (theme: DefaultTheme): MessageOptions<typeof PatientIncompleteStatusType> => ({
   INCOMPLETE: {
      color: theme.warning,
      backgroundColor: theme.warningLighter,
   },
});

type PatientAddressIncompleteStatusProps = {
   patientId: number;
   patientAddress: Address | undefined;
};

export const PatientAddressIncompleteStatus = (props: PatientAddressIncompleteStatusProps): ReactElement => {
   const theme = useTheme();
   const options = useMemo(() => createOptions(theme), [theme]);
   return (
      <StyledPatientAddressIncompleteStatus
         displayIndicator
         type={PatientIncompleteStatusType.INCOMPLETE}
         options={options}
         label={
            <PatientAddressModalOpener patientAddress={props.patientAddress} patientId={props.patientId}>
               {({ openModal }) => (
                  <Trans
                     i18nKey={draftPrescriptionsTranslationKeys.patientHasIncompleteAddress}
                     components={{
                        link: (
                           <Link
                              testId={'openPatientAddressModal'}
                              block={false}
                              onClick={openModal}
                              label={draftPrescriptionsTranslationKeys.fillHere}
                           />
                        ),
                     }}
                  />
               )}
            </PatientAddressModalOpener>
         }
         testId={'patientAddressIncomplete'}
      />
   );
};
